import Vue from 'vue'

const initialState = {
  list: [],
  departments: [],
  issue: {},
  loading: false,
  detail: {}
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, {params, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/issues/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getIssue({commit}, {projectId, issueId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/issues/${issueId}/`).then(response => {
          commit('SET', {key: 'issue', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {issue, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`project_control/projects/${projectId}/issues/`, issue).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {projectId, issue}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`project_control/projects/${projectId}/issues/${issue.id}/`, issue).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, {projectId, issueId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${projectId}/issues/${issueId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations ({commit}, projectId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(`project_control/projects/${projectId}/issues/relations/`).then((response) => {
          commit('SET', {key: 'departments', val: response.data.departments})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
